/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\OfferRowUserSingle\OfferRowUser.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday October 9th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday October 9th 2024 3:43:03 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { TableCell } from "@mui/material";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { OfferUserType } from "Types/offer.type";
import { Link } from "react-router-dom";
import Styles from "Content/Cart/OfferRowUserSingle/OfferRowUser.module.css";
import CollapsRow from "../../Table/CollapsRow/CollapsRow";
import { OfferCollapsContent } from "../OfferCollapsContent/OfferCollapsContent";
import translator from "MultiLanguage/TranslationWrapper";

type OfferRowUserProps = {
    Offer: OfferUserType
};

export function OfferRowUser(props: OfferRowUserProps) {
    return (
        <CollapsRow collapseChildren={<OfferCollapsContent offerID={props.Offer.id} />}>
            <TableCell align="center" className={`${Styles.cells}`}>
                <p className="m-0">{new Date(props.Offer.CreatedAt).toLocaleDateString()}</p>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`}>
                <Link to={RouterPathResolver.routeCarsId.path.replace(":id", props.Offer.Car.id)} className="m-0 text-capitalize">{props.Offer.Car.Brand} {props.Offer.Car.Model}</Link>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`}>
                <p className="m-0">{props.Offer.Quantity}</p>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`}>
                <p className="m-0">{props.Offer.Price} €/HT</p>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`}>
                <p className="m-0">{props.Offer.Mileage}</p>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`}>
                <p className="m-0">{props.Offer.Month}</p>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`} >
                <p className="m-0">{props.Offer._count.OfferFile}</p>
            </TableCell>
            <TableCell align="center" className={`${Styles.cells}`} >
                <p className="m-0">{translator.decode(`Status.${props.Offer.Status}`)}</p>
            </TableCell>
        </CollapsRow>
    );
};
